import { defineComponent } from "vue";

const appleMapsUrl = "http://maps.apple.com/?daddr=";
const googleMapsUrl = "https://maps.google.com/maps?daddr=";

export function openMapView(...params: string[]) {
  const destination = encodeURIComponent(params.filter((v) => !!v).join(","));
  let url = "";

  if (
    //  if iOS, open Apple Maps
    navigator.platform.indexOf("iPhone") != -1 ||
    navigator.platform.indexOf("iPod") != -1 ||
    navigator.platform.indexOf("iPad") != -1
  ) {
    // Firefox for iOS prepends 'http://' to a URL, meaning it has to be removed
    // from appleMapsUrl before opening in a new window.
    url = navigator.userAgent.includes("FxiOS")
      ? appleMapsUrl.slice(7) + destination
      : appleMapsUrl + destination;
  } else {
    url = googleMapsUrl + destination;
  }

  window.open(url);
}

export const BmExternalLinks = defineComponent({
  methods: {
    openExternalMap(...params: string[]) {
      openMapView(...params);
    },
  },
});
